module.exports = __webpack_public_path__ + "img/qilin-stage2.43643f3e.png";